import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'SubcontractorCategory' })
export class SubcontractorCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
